export default {
  grid: [
    {
      image: 'macImage',
      headingBlack: 'How to record your screen on Mac',
      link: 'https://screenapp.io/blog/guides/how-to-screen-record-on-mac.html',
    },
    {
      image: 'windowsImage',
      headingBlack: 'How to record your screen on Windows',
      link: "https://screenapp.io/blog/guides/how-to-screen-record-on-windows.html",
    },
    {
      image: 'linuxImage',
      headingBlack: 'How to record your screen on Linux',
      link: 'https://screenapp.io/blog/guides/how-to-screen-record-on-ubuntu.html',
    },
  ],
};
